/* @ngInject */
function InternalApprovalHistoryController ($scope, $rootScope, ApprovalsService, ToastService) {
  $scope.flags = {
    isCollapsed: true
  }
  $scope.approvals = []

  const api = {
    _getAllInternalApprovalForTask,
    _successGetAllInternalApprovalForTask,
    _errorGetAllInternalApprovalForTask
  }
  this.getApi = () => api

  activate()
  function activate () {
    if (!$scope.task) return

    api._getAllInternalApprovalForTask($scope.task.id)
  }

  $rootScope.$on('internal-approval-history.reload', () => {
    api._getAllInternalApprovalForTask($scope.task.id)
  })

  $scope.onCollapse = () => {
    $scope.flags.isCollapsed = !$scope.flags.isCollapsed
  }

  function _getAllInternalApprovalForTask (taskId) {
    ApprovalsService.getAllInternalApprovalForTask(taskId)
      .then(api._successGetAllInternalApprovalForTask)
      .catch(api._errorGetAllInternalApprovalForTask)
  }

  function _successGetAllInternalApprovalForTask (response) {
    $scope.approvals = response
  }

  function _errorGetAllInternalApprovalForTask (error) {
    console.log({ error })
    ToastService.showErrorToast('Não foi possível carregar o histórico de aprovações')
  }
}

export { InternalApprovalHistoryController }
